import { Box } from '@mui/material';
import { SxProps } from '@mui/system';
import { useTheme } from '@mui/material/styles';
import { ReactNode } from 'react';

interface SectionProps {
  sx?: SxProps;
  children?: ReactNode;
}

const Section = (props: SectionProps) => {
    const theme = useTheme();
    return (
        <Box
            sx={{
                ...theme.sections.fixedWidth,
                ...props.sx,
                height: '100%',
                accentColor: 'inherit',
                filter: 'none',
            }}
        >
            {props.children}
        </Box>
    );
};

export default Section;
